import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { getParentHierarchy } from 'src/@smartmanufacturing/common/custom_methods';
import { Multilingual } from 'src/app/services/multilingual';
import { TranslaterService } from 'src/app/services/translater.service';
import { BaseApi } from 'src/backend/api/base-api';

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.scss']
})
export class BreadCrumbComponent implements OnInit {

  breadcrumList: any[] = [];
  menus: any[] = [];
  currentMenuId: string = '';
  langObj: any;
  pageId: string;
  moduleId: any;
  ParameterTypeGripApi: any;
  HeaderGripApi: any;
  lang: Multilingual;
  languageDir: string;
  constructor(private baseApi: BaseApi, public router: Router, public translate: TranslateService, public translater: TranslaterService) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
  }

  ngOnInit() {
    this.menus = this.baseApi.getMenuCardsSession();
    this.currentMenuId = this.baseApi.getCurrentMenuID();
    this.getBreadcrumList();
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  public getLangWords() {
    const key = {
      ModuleId: 0,
      PageId: 0,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : this.translate.currentLang === 'gr'
                  ? 5
                  : this.translate.currentLang === 'du'
                    ? 6
                    : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      this.lang = new Multilingual(this.translater, this.translate);
      this.lang.getLangWords();
    });
  }

  getBreadcrumList(): any {
    const menusForBreadCrumbs = getParentHierarchy(this.menus, this.currentMenuId)
    this.breadcrumList = [...menusForBreadCrumbs];
    this.getLangWords();
  }



  displayRightmenu(menuId: string, url: any, type: string): any {
    this.baseApi.saveCurrentMenuID(menuId);
    switch (type) {
      case 'subheading':
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['Home']));
        break;
      case 'dropdown':
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['Home']));
        break;
      case 'link':
        if (url.indexOf('/Home/ExternalLink?link=') > -1) {
          url = url.replace('/Home/ExternalLink?link=', '');
          window.open(url, '_blank');
        }
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate([url]));
        break;
      default:
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['Home']));
        break;
    }
  }

}
